import { TemplateParameterSchema } from '@backstage/plugin-scaffolder-react';
import { flatten } from 'lodash';
import { stringifyEntityRef } from '@backstage/catalog-model';

const isDefined = (value: unknown) => value !== null && value !== undefined;

export function getFormDefaults(
  formData: any,
  template: TemplateParameterSchema | undefined,
) {
  if (!template) {
    return {};
  }
  const defaults = flatten(
    template.steps.map(step => {
      return Object.entries(step.schema.properties ?? {})
        .filter(
          ([k, prop]) =>
            formData?.hasOwnProperty(k) &&
            isDefined(prop.default) &&
            !isDefined(formData[k]),
        )
        .map(([key, prop]) => {
          return [key, prop.default];
        });
    }),
  );

  return Object.fromEntries(defaults);
}

export const unknownName = '_unknown';

export function getTemplateRefFromPath(): string {
  const templateName = document.location.pathname.split('/').at(-1);
  const entity = {
    kind: 'Template',
    name: templateName || unknownName,
  };
  return stringifyEntityRef(entity);
}
